export default __webpack_public_path__ + "static/media/icon_message-2.25cbf03f.svg";